import { useTranslation } from 'react-i18next';
import './EnhancedEventViewFlightSegment.scss';
import { eventTransportationType } from '../../../constants/myBlockMonth';
import { formatNumToTime, getDeviationValue } from '../../../helpers/timeHelpers';
import { useAuth } from '../../../providers/Auth';


function EnhancedEventViewFlightSegment({ actualView, pairingSegment }) {

  const { t } = useTranslation();
  const { user } = useAuth();
  const fullName = user && '' + user?.attributes.given_name + ' ' + user?.attributes.family_name;

  const getDeparturePlace = () => {
    if (pairingSegment && pairingSegment?.departure && pairingSegment?.departure?.airportDescription) {
      return pairingSegment?.departure?.airportDescription;
    }
    return '';
  }

  const getArrivalPlace = () => {
    if (pairingSegment && pairingSegment?.arrival && pairingSegment?.arrival?.airportDescription) {
      return  pairingSegment?.arrival?.airportDescription;
    }
    return '';
  }

  const getFlightNumber = () => {
    if(!pairingSegment && !pairingSegment?.fltNo) return 'NA';
    let flightNumber = pairingSegment?.fltNo;
    let flightRegex = new RegExp('^0+(?!$)','g');
    return pairingSegment?.deadhead && pairingSegment?.fltNo !== eventTransportationType.LIMO ? (pairingSegment?.carierCode+flightNumber.replaceAll(flightRegex,'')) : flightNumber.replaceAll(flightRegex,'');
  }

  return (
    <div className='c-ev-flight-segment'>
      <div className='c-flight-number'>
        <p className={pairingSegment?.deadhead ? 'flight-number flight-number--deadhead' : 'flight-number'}>{getFlightNumber()}</p>
      </div>
      <div className='c-segment-details'>
        <div className='c-segment-airport-codes'>
          <p className='airport-code'>{pairingSegment?.departure?.airportCode}</p>
          {pairingSegment?.deadhead ?
            pairingSegment?.fltNo === eventTransportationType.LIMO ? 
              <>
                <i className='icon-limo-Desktop icon-airplane-desktop'></i>
                <i className='icon-limo-iPad icon-airplane-ipad'></i>
              </>
            :
              <>
                <i className='icon-deadhead-Desktop icon-airplane-desktop'></i>
                <i className='icon-deadhead-iPad icon-airplane-ipad'></i>
              </>
          :
            <>
              <i className='icon-airplane-Desktop icon-airplane-desktop'></i>
              <i className='icon-airplane-iPad icon-airplane-ipad'></i>
            </>
          }
          <p className='airport-code'>{pairingSegment?.arrival?.airportCode}</p>
        </div>
        <div className='c-segment-locations'>
          <div className='c-location'>
            <p className='location__name'>{getDeparturePlace()}</p>
            <p className='c-location__time'>{t('myBlockMonth.departure')} 
              <span className={actualView && pairingSegment?.departure?.time?.deviation ? (pairingSegment?.departure?.time?.deviation > 0 ? 'time__dep-arr time__dep-arr--late':'time__dep-arr time__dep-arr--early'):'time__dep-arr'}>
                {formatNumToTime(pairingSegment?.departure?.time?.value)} 
                {actualView && pairingSegment?.departure?.time?.deviation ? ' ('+getDeviationValue(pairingSegment?.departure?.time?.deviation)+')' :''}
              </span>
            </p>
          </div>
          <div className='c-location c-location--arr'>
            <p className='location__name'>{getArrivalPlace()}</p>
            <p className='c-location__time'>{t('myBlockMonth.arrival')}             
              <span className={actualView && pairingSegment?.arrival?.time?.deviation ? (pairingSegment?.arrival?.time?.deviation > 0 ? 'time__dep-arr time__dep-arr--late':'time__dep-arr time__dep-arr--early'):'time__dep-arr'}>
                {formatNumToTime(pairingSegment?.arrival?.time?.value)} 
                {actualView && pairingSegment?.arrival?.time?.deviation ? ' ('+getDeviationValue(pairingSegment?.arrival?.time?.deviation)+')' :''}
              </span>
              </p>
          </div>
        </div>
      </div>
      <div className='c-crew-details'>
        <div className='c-flight-crew'>
          <p className='flight-crew__header'>{t('myBlockMonth.crewMember')}</p>
          {pairingSegment?.crewMembers.map((member, index) => {
            return (
              <p key={index} className={member.toLowerCase().includes(fullName?.toLowerCase()) ? 'flight-crew__user' : 'flight-crew__normal'}>{member}</p>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default EnhancedEventViewFlightSegment;
